import axios from "axios";
import { alertFailed } from "@/composables/swAlert";
import router from "@/router";
import store from "../store/index";
import useSSOFunction from "@/composables/composableGestioneSSO";

export const baseUrlApiApp =
  process.env.VUE_APP_IS_BRANCH_PROD == "1"
    ? process.env.VUE_APP_ENDPOINT_API_PROD
    : process.env.VUE_APP_ENDPOINT_API_TEST;

// Compone l'URL esatto di una richiesta GET (base + endpoint + querystring),
// come farebbe axios. Usato per copiare negli appunti il link diretto di
// download di un file (endpoint di download con i suoi parametri GET), senza
// effettuare la chiamata. I valori null/undefined vengono ignorati.
export const buildRequestUrl = (
  endpoint: string,
  params: Record<string, unknown> = {}
): string => {
  const base = String(baseUrlApiApp || "").replace(/\/+$/, "");
  const path = String(endpoint || "").replace(/^\/+/, "");
  const qs = Object.entries(params)
    .filter(([, v]) => v !== null && v !== undefined)
    .map(
      ([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`
    )
    .join("&");
  return `${base}/${path}${qs ? `?${qs}` : ""}`;
};

export const dbManagApp = axios.create({
  baseURL: baseUrlApiApp,
});
dbManagApp.interceptors.request.use((config) => {
  const token = localStorage.getItem("tokenAdb2c");
  config.headers["Authorization"] = "Bearer " + token;
  return config;
});

export const requestAppPost = async (
  endpoint: string,
  payload: Record<string, unknown>
) => {
  return dbManagApp
    .post(endpoint, payload)
    .then((res) => {
      store.commit("setManutenzione", false);

      // throw new Error("525");
      if (res.status == 401) {
        // msalInstance.logoutRedirect();
        throw new Error("401");
      }
      if (res.status == 525) {
        // msalInstance.logoutRedirect();
        throw new Error("525");
      }

      return {
        ...res,
      };
    })
    .catch((e) => {
      const { logoutFunction } = useSSOFunction();
      console.log(e.message, e.response, e == "525");
      if (e.message == "525") {
        console.log(e.message, e == "525");
        store.commit("setManutenzione", true);
        router.push("/manutenzione");
        const custom_response = { status: 525 };
        return {
          ...custom_response,
        };
      }
      if (e == "401") {
        alertFailed(
          "Sessione Scaduta. Per continuare, effettuare nuovamente il login"
        ).then(() => logoutFunction());
        return;
      }

      if (e.response.data.message == "Utente non autorizzato") {
        logoutFunction();
        return;
      }

      return {
        ...e.response,
      };
    });
};

export const requestAppPut = async (
  endpoint: string,
  payload: Record<string, unknown>
) => {
  return dbManagApp
    .put(endpoint, payload)
    .then((res) => {
      store.commit("setManutenzione", false);

      if (res.status == 401) {
        throw new Error("401");
      }
      if (res.status == 525) {
        throw new Error("525");
      }

      return {
        ...res,
      };
    })
    .catch((e) => {
      const { logoutFunction } = useSSOFunction();
      if (e.message == "525") {
        store.commit("setManutenzione", true);
        router.push("/manutenzione");
        const custom_response = { status: 525 };
        return {
          ...custom_response,
        };
      }
      if (e == "401") {
        alertFailed(
          "Sessione Scaduta. Per continuare, effettuare nuovamente il login"
        ).then(() => logoutFunction());
        return;
      }

      if (e.response && e.response.data.message == "Utente non autorizzato") {
        logoutFunction();
        return;
      }

      return {
        ...e.response,
      };
    });
};

export const requestBasePost = async (
  endpoint: string,
  payload: Record<string, unknown>
) => {
  return dbManagApp
    .post(endpoint, payload)
    .then((res) => {
      store.commit("setManutenzione", false);
      if (res.status == 401) {
        // msalInstance.logoutRedirect();
        throw new Error("401");
      }
      if (res.status == 525) {
        // msalInstance.logoutRedirect();
        throw new Error("525");
      }
      return {
        ...res,
      };
    })
    .catch((e) => {
      const { logoutFunction } = useSSOFunction();
      if (e == "401") {
        alertFailed(
          "Sessione Scaduta. Per continuare, effettuare nuovamente il login"
        ).then(() => logoutFunction());
      }
      if (e == "525") {
        store.commit("setManutenzione", true);
        router.push("/manutenzione");
      }
      return {
        ...e.response,
      };
    });
};

let controller;

export const abortRequest = () => {
  controller.abort("Ricerca utente");
};

export const requestAppGet = async (
  endpoint: string,
  params: Record<string, unknown>
) => {
  return dbManagApp
    .get(endpoint, params)
    .then((res) => {
      store.commit("setManutenzione", false);
      if (res.status == 401) {
        // msalInstance.logoutRedirect();
        throw new Error("401");
      }
      if (res.status == 525) {
        // msalInstance.logoutRedirect();
        throw new Error("525");
      }
      return {
        ...res,
      };
    })
    .catch((e) => {
      const { logoutFunction } = useSSOFunction();
      if (e == "401") {
        alertFailed(
          "Sessione Scaduta. Per continuare, effettuare nuovamente il login"
        ).then(() => logoutFunction());
      } else if (e == "525") {
        store.commit("setManutenzione", true);
        router.push("/manutenzione");
      } else {
        alertFailed(
          e.response.data.message
            ? e.response.data.message
            : "Attenzione! Si è verificato un errore. Riprovare più tardi"
        );
      }

      return {
        ...e.response,
      };
    });
};

// Con responseType "blob" anche il corpo di una risposta di errore è un Blob
// ({ result, statusCode, message }): va letto come testo e parsato per
// mostrare in alertFailed il message del backend. Fallback su un messaggio
// generico se il corpo non è leggibile/JSON.
const messaggioErroreDownload = async (data: unknown): Promise<string> => {
  const generico = "Errore durante il download del file. Riprovare.";
  try {
    if (data instanceof Blob) {
      const json = JSON.parse(await data.text());
      return json && json.message ? String(json.message) : generico;
    }
    if (data && typeof data === "object") {
      const msg = (data as { message?: unknown }).message;
      return msg ? String(msg) : generico;
    }
  } catch {
    return generico;
  }
  return generico;
};

export const requestDownloadGet = async (
  endpoint: string,
  payload: Record<string, unknown>
) => {
  return dbManagApp
    .get(endpoint, { params: payload, responseType: "blob" })
    .then((res) => {
      store.commit("setManutenzione", false);
      if (res.status == 401) {
        throw new Error("401");
      }
      if (res.status == 525) {
        throw new Error("525");
      }
      return {
        ...res,
      };
    })
    .catch(async (e) => {
      const { logoutFunction } = useSSOFunction();
      const status = e?.response?.status;
      if (e == "401" || status == 401) {
        alertFailed(
          "Sessione Scaduta. Per continuare, effettuare nuovamente il login"
        ).then(() => logoutFunction());
      } else if (e == "525" || status == 525) {
        store.commit("setManutenzione", true);
        router.push("/manutenzione");
      } else {
        alertFailed(await messaggioErroreDownload(e?.response?.data));
      }

      return {
        ...e.response,
      };
    });
};

export const sendFile = axios.create({
  method: "post",
  baseURL: `${baseUrlApiApp}`,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: "Bearer " + localStorage.getItem("tokenAdb2c"),
  },
  // onUploadProgress: function (progressEvent) {
  //   var percentCompleted = Math.round(
  //     (progressEvent.loaded * 100) / progressEvent.total
  //   );
  // },

  /* other custom settings */
});
sendFile.interceptors.request.use((config) => {
  const token = localStorage.getItem("tokenAdb2c");
  config.headers["Authorization"] = "Bearer " + token;
  return config;
});
export const fileSender = async (bodyFormData, apiLink) => {
  return sendFile
    .post(apiLink, bodyFormData)
    .then((res) => {
      store.commit("setManutenzione", false);
      if (res.status == 401) {
        // msalInstance.logoutRedirect();
        throw new Error("401");
      }
      if (res.status == 525) {
        // msalInstance.logoutRedirect();
        throw new Error("525");
      }
      return {
        ...res,
      };
    })
    .catch((e) => {
      const { logoutFunction } = useSSOFunction();
      if (e == "401") {
        alertFailed(
          "Sessione Scaduta. Per continuare, effettuare nuovamente il login"
        ).then(() => logoutFunction());
      } else if (e == "525") {
        store.commit("setManutenzione", true);
        router.push("/manutenzione");
      } else {
        alertFailed(
          e.response.data.message
            ? e.response.data.message
            : "Attenzione! Si è verificato un errore. Riprovare più tardi"
        );
      }
      return {
        ...e.response,
      };
    });
};

const dbManagControlloTokenFCH = axios.create({
  baseURL: baseUrlApiApp,
  // headers: {
  //   Authorization: "Bearer " + localStorage.getItem("id_token"),
  // },
  /* other custom settings */
});

export const requests = {
  dbManag: dbManagApp,
  baseUrlApiApp,
  dbManagControlloTokenFCH,
};
